import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";



@Injectable({
  providedIn: 'root'
})
export class HeightService {
  constructor(private httpClient: HttpClient) {}
  private activeHeight: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  getActiveHeight() {
    return this.activeHeight.value;
  }


  setActiveHeight(value: number) {
    this.activeHeight.next(value);
  }
}
